import dynamic from 'next/dynamic';

import { Modal } from '~components/Modals/Base';

import type { ReviewModalProps } from './types';
const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const ReviewModal = ({
	open,
	locked,
	onClose,
	'data-name': dataName,
	...props
}: ReviewModalProps) => (
	<Modal open={open} locked={locked} onClose={onClose} data-name={dataName}>
		<Content open={open} onClose={onClose} locked={locked} {...props} />
	</Modal>
);
